<span class="cb-margin-left-2x mat-body-2">Assign any Changes where Design Work is requred to this Revision</span>
<cb-design-scheme-assigned-changes [mappedItem]="mappedItem"></cb-design-scheme-assigned-changes>
